import { namePatternMatch, emailPatternMatch } from "../../utilities/helpers";

import { isValidPhoneNumber } from "react-phone-number-input";

import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Stack from "react-bootstrap/Stack";

import { PhoneNumberInput } from "../../components/PhoneNumberInput";
import { Error } from "../../components/Error";

/**
 * Depositor step for the deposit modal — grid layout matches admin deposit mockup.
 */
export default function DepositAssignToForm({
  assignTo,
  onAssignToChange,
  noteText,
  onNoteChange,
  isValidEmail,
  setIsValidEmail,
  isValidNumber,
  setIsValidNumber,
}) {
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "email" || value === "" || e.target.validity.valid) {
      onAssignToChange(name, value);
    }
  };

  const handleValidEmail = (e) => {
    if (!emailPatternMatch(e.target.value)) {
      setIsValidEmail(false);
    } else {
      setIsValidEmail(true);
    }
  };

  const handleValidNumber = () => {
    if (!assignTo.phoneNumber) {
      setIsValidNumber(true);
      return;
    }
    setIsValidNumber(isValidPhoneNumber(assignTo.phoneNumber));
  };

  return (
    <Stack gap={2}>
      <Form.Group className="mb-0" controlId="deposit-org-name">
        <Form.Label className="form-label">
          Organization name (optional)
        </Form.Label>
        <Form.Control
          type="text"
          name="organizationName"
          placeholder="Enter your organization name"
          value={assignTo?.organizationName || ""}
          onChange={handleChange}
          autoComplete="organization"
          className="form-control-height"
        />
      </Form.Group>

      <Row className="g-2 gx-md-3 gy-2 m-0">
        <Col xs={12} md={6} className="ps-0 pe-md-2">
          <Form.Group className="mb-0" controlId="deposit-first-name">
            <Form.Label className="form-label">First name</Form.Label>
            <Form.Control
              type="text"
              name="firstName"
              pattern={namePatternMatch}
              placeholder="Enter your first name"
              value={assignTo?.firstName || ""}
              onChange={handleChange}
              required
              autoComplete="given-name"
              className="form-control-height"
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={6} className="pe-0 ps-md-2">
          <Form.Group className="mb-0" controlId="deposit-last-name">
            <Form.Label className="form-label">Last name</Form.Label>
            <Form.Control
              type="text"
              name="lastName"
              pattern={namePatternMatch}
              placeholder="Enter your last name"
              value={assignTo?.lastName || ""}
              onChange={handleChange}
              required
              autoComplete="family-name"
              className="form-control-height"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="g-2 gx-md-3 gy-2 m-0">
        <Col xs={12} md={6} className="ps-0 pe-md-2">
          <Form.Group className="mb-0" controlId="deposit-email">
            <Form.Label className="form-label">Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              placeholder="Enter your email address"
              value={assignTo?.email || ""}
              onChange={handleChange}
              onBlur={handleValidEmail}
              required
              autoComplete="email"
              className={`form-control-height ${!isValidEmail ? "error-border" : ""}`}
            />
            {!isValidEmail && <Error type="invalidEmail" />}
          </Form.Group>
        </Col>
        <Col xs={12} md={6} className="pe-0 ps-md-2">
          <Form.Group className="mb-0" controlId="deposit-phone">
            <Form.Label className="form-label">Phone number</Form.Label>
            <PhoneNumberInput
              phoneNumber={assignTo?.phoneNumber}
              setPhoneNumber={(value) => onAssignToChange("phoneNumber", value)}
              isRequired={false}
              onBlur={handleValidNumber}
              hasError={!isValidNumber}
            />
          </Form.Group>
        </Col>
      </Row>

      <Form.Group className="mb-0" controlId="deposit-note">
        <Form.Label className="form-label">Note</Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          placeholder="Add an optional note"
          value={noteText ?? ""}
          onChange={(e) => onNoteChange(e.target.value)}
          style={{ minHeight: "120px", resize: "vertical" }}
        />
      </Form.Group>
    </Stack>
  );
}
